import { render, staticRenderFns } from "./VAlignTop.vue?vue&type=template&id=427076fa&scoped=true&"
var script = {}
import style0 from "./VAlignTop.vue?vue&type=style&index=0&id=427076fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427076fa",
  null
  
)

export default component.exports